//TODO: refactor
// used for nav list at the top of the page
const getPersistedValue = (key) => {
    const sessionValue = sessionStorage.getItem(key);

    if (sessionValue !== null) {
        return sessionValue;
    }

    return localStorage.getItem(key);
};

const getCurrentCompany = () => {
    return getPersistedValue('currentCompany');
};
const getCurrentPartner = () => {
    return getPersistedValue('currentPartner');
};
const getCurrentWholesaler = () => {
    return getPersistedValue('currentWholesaler');
};
const getCurrentCompanyData = () => {
    try {
        const currentCompanyData = localStorage.getItem('currentCompanyData');

        return currentCompanyData ? JSON.parse(currentCompanyData) : null;
    } catch (error) {
        return null;
    }
};

const getCurrentWholesalerData = () => {
    try {
        const currentWholesalerData = localStorage.getItem(
            'currentWholesalerData',
        );

        return currentWholesalerData ? JSON.parse(currentWholesalerData) : null;
    } catch (error) {
        return null;
    }
};

const currentCompany =
    getCurrentCompany() === 'null' ? null : getCurrentCompany();
const currentWholesaler =
    getCurrentWholesaler() === 'null' ? null : getCurrentWholesaler();
const storedCurrentCompanyData = getCurrentCompanyData();
const storedCurrentWholesalerData = getCurrentWholesalerData();
const storedCurrentCompanyDataId =
    storedCurrentCompanyData?.id || storedCurrentCompanyData?.companyID;

const initNavListState = {
    companiesAndPartners: [],
    wholesalers: [],
    companiesAndPartnersLoading: true,
    wholesalersLoading: true,
    currentCompanyData:
        storedCurrentCompanyDataId === currentCompany
            ? storedCurrentCompanyData
            : {
                  isTrial: false,
              },
    currentPartner: getCurrentPartner() === 'null' ? null : getCurrentPartner(),
    currentWholesaler,
    // Only trust the persisted copy when it belongs to the wholesaler that is
    // still selected, so a stale name is never shown (2807)
    currentWholesalerData:
        storedCurrentWholesalerData?.id === currentWholesaler
            ? storedCurrentWholesalerData
            : null,
    currentCompany,
    currentCompanyPlatforms: null,
};

export const navigationListsReducer = (state = initNavListState, action) => {
    switch (action.type) {
        case 'CHANGE_COMPANIES_AND_PARTNERS_LOADING':
            return { ...state, companiesAndPartnersLoading: action.payload };
        case 'CHANGE_WHOLESALERS_LOADING':
            return { ...state, wholesalersLoading: action.payload };
        case 'CHANGE_COMPANIES_AND_PARTNERS':
            return { ...state, companiesAndPartners: action.payload };
        case 'CHANGE_WHOLESALERS':
            return { ...state, wholesalers: action.payload };
        case 'CHANGE_CURRENT_COMPANY_DATA':
            localStorage.setItem(
                'currentCompanyData',
                JSON.stringify(action.payload || {}),
            );
            return { ...state, currentCompanyData: action.payload };
        case 'CHANGE_CURRENT_COMPANY':
            sessionStorage.setItem('currentCompany', action.payload);
            localStorage.setItem('currentCompany', action.payload);
            // Reset platforms so stale data from the previous company does not
            // persist (Bug 2329: numbers table hidden after switching to a
            // company with fewer/zero platforms).
            return {
                ...state,
                currentCompany: action.payload,
                currentCompanyPlatforms: null,
            };
        case 'CHANGE_CURRENT_COMPANY_PLATFORMS':
            return { ...state, currentCompanyPlatforms: action.payload };
        case 'CHANGE_CURRENT_PARTNER':
            sessionStorage.setItem('currentPartner', action.payload);
            localStorage.setItem('currentPartner', action.payload);
            return { ...state, currentPartner: action.payload };
        case 'CHANGE_CURRENT_WHOLESALER_DATA':
            localStorage.setItem(
                'currentWholesalerData',
                JSON.stringify(action.payload || {}),
            );
            return { ...state, currentWholesalerData: action.payload };
        case 'CHANGE_CURRENT_WHOLESALER':
            sessionStorage.setItem('currentWholesaler', action.payload);
            localStorage.setItem('currentWholesaler', action.payload);
            // Drop the previous wholesaler's data so nothing renders its name
            // while the new one loads (2807)
            return {
                ...state,
                currentWholesaler: action.payload,
                currentWholesalerData: null,
            };
        case 'LOGOUT':
            sessionStorage.clear();
            localStorage.removeItem('currentCompany');
            localStorage.removeItem('currentPartner');
            localStorage.removeItem('currentWholesaler');
            localStorage.removeItem('currentCompanyData');
            localStorage.removeItem('currentWholesalerData');
            return {
                companiesAndPartners: [],
                wholesalers: [],
                companiesAndPartnersLoading: true,
                wholesalersLoading: true,
                currentCompanyData: {},
                currentPartner: null,
                currentWholesaler: null,
                currentWholesalerData: null,
                currentCompany: null,
                currentCompanyPlatforms: null,
            };

        default:
            return state;
    }
};
